import RunbookName from "./RunbookName";
import RunbookDescription from "./RunbookDescription";
import RunbookConclusion from "./RunbookConclusion";
import Feedback from "./Feedback";
import React from "react";
import Diagnostics from "./Diagnostics";
import { useDispatch, useSelector } from "react-redux";
import {getRunbook, getRunbookByRunbookId, updateRunbook} from "store/actions";
import { useEffect, useState, useRef } from "react";
import AllFeedbacks from "./AllFeedbacks";
import "./style.scss";
import {Badge} from "reactstrap";


const Runbook = ({runbookView, handleView, id, metricName, runbook_id }) => {
  const topRef = useRef(null);
  const dispatch = useDispatch();
  const {runbook_details}  = useSelector(state => ({runbook_details: state.AlertLog.runbook_details}))
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(false);
  const [descFromChild, setDescFromChild] = useState('');
  const [nameFromChild, setNameFromChild] = useState('')
  const [runbookToEdit, setRunbookToEdit ]= useState(runbook_details);
  const [updatedBy, setUpdatedBy] = useState(null);
  const [createdBy, setCreatedBy] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [onRunBookPage, setOnRunBookPage] = useState(false);

  const handleEditClick = () => {
    setEdit(!edit);
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  useEffect(() => {
    setRunbookToEdit(runbook_details);
  }, [Object.keys(runbook_details).length]);


  useEffect(() => {
    if(runbookView){
      setOnRunBookPage(true)
    }
  }, [runbookView]);

  useEffect(()=>{
    dispatch(getRunbookByRunbookId(runbook_id));
  }, [runbook_id]);

  useEffect(() => {
    setLoading(false);
  }, [getRunbook, getRunbookByRunbookId,isHovered, setRunbookToEdit]);

  function handleNameFromChild(name) {
    setNameFromChild(name);
    runbookToEdit.runbook.name = name
  }

  function handleDescFromChild(data) {
    setDescFromChild(data);
    runbookToEdit.runbook.description = data;
  }

  function handleConclusionFromChild(data) {
    runbookToEdit.runbook.conclusion = data;
  }

  function handleDiagnosticFromChild(data) {
    runbookToEdit.instructions = data;
  }

  function handleRecoveryFromChild(data) {
    runbookToEdit.recovery_instructions = data;
  }

  const editRunbook = () => {
    const runbookId = runbook_details?.runbook?.id
    const data = {
      name: runbookToEdit?.runbook.name,
      description: runbookToEdit?.runbook.description,
      conclusion: runbookToEdit?.runbook.conclusion,
      diagnostic_instructions: runbookToEdit?.instructions,
      recovery_instructions: runbookToEdit?.recovery_instructions
    }
    dispatch(updateRunbook(data, runbookId));
    setEdit(false);
    setLoading(true)
    setTimeout(()=> {
      dispatch(getRunbook(id));
      setLoading(false)
    }, 1000)
    location.reload()
  }

  if(!runbook_details || runbook_details.error === "No runbook associated with this alert log"){
    return null;
  } else
  
  return(
    <React.Fragment> 
      {loading ? 
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-primary m-auto"></div>
      </div>
        :
       <div>
        <div
          className={`d-flex ${runbookView === false ? '' : 'pe-4'}  justify-content-center`}
          style={{width:  '100%'}} >
          {/*{runbookView && */}
          {/*<div className="bx bx-undo pe-3" onClick={handleView} style={{fontSize:"30px", cursor:"pointer", color:"white"}}></div>}*/}
            <div className={`d-flex-row  ${runbookView ? 'mt-1' : 'ps-0'}`} style={{width:"100%"}}>
              <div className="d-flex align-items-start w-100 justify-content-between">
                <div className="d-flex-row">
                {edit ? <p className="font-size-15">Title:</p> : null}
                <div className="d-flex align-items-center justify-content-between gap-3" ref={topRef}> {/* Ref added here */}
                  <RunbookName
                    editable={edit}
                    sendDataToParent={handleNameFromChild}
                    name={metricName}
                    editedName={runbook_details?.runbook?.name}
                    userUpdated={runbook_details?.runbook?.updated_by !== null ||
                      runbook_details?.instructions[0]?.updated_by !== null ||
                      runbook_details?.recovery_instructions[0]?.updated_by !== null}
                    className='w-100'
                  />
                  {/*{runbook?.runbook?.updated_by === null && (*/}
                  {/*  <Badge*/}
                  {/*    className="font-size-11 ms-2"*/}
                  {/*    color={"warning"}>*/}
                  {/*    AI Generated*/}
                  {/*  </Badge>*/}
                  {/*)}*/}
                  {/*{edit &&*/}
                  {/*  <div className="d-flex">*/}
                  {/*    <div className="badge-soft-success badge bg-secondary font-size-16 mb-4" style={{height:"26px"}}>Edit mode</div>*/}
                  {/*  </div>*/}
                  {/*}*/}
                </div>
                </div>
                
                <div className="d-flex gap-2" style={{position: `${edit && 'absolute'}`, top:`2%`, right: `7%`, zIndex:"3"}}>
                  {!edit && 
                  <div className={`${runbookView && 'mt-2'}`}>
                    {runbook_details && (updatedBy ? `Modified by ${updatedBy}` : createdBy ? `Created by ${createdBy}`: null)}
                  </div>}
                  {runbookView && 
                  <>
                  {edit && <button onClick={() => editRunbook()} className="btn btn-success">Save changes</button>}
                  <button 
                    onClick={handleEditClick} 
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    className={`d-flex justify-content-center btn ${edit ? 'btn-primary' : 'btn-outline-success'} align-items-center gap-1`}
                    >
                    <span>{edit ? <>Cancel</> : <>Edit</> }</span>
                    <i  className={`${!edit ? 'bx bxs-edit-alt' : ''} ${!edit ? (isHovered ? 'text-white' : 'text-success') : 'text-white'}`} style={{fontSize:"14px", color:`${isHovered && 'white'}`}}
                    />
                  </button>
                  </>
                  }    
                </div>
              </div>
              
              {edit && <div>Description:</div>}
              <RunbookDescription
                sendDataToParent={handleDescFromChild}
                editable={edit}
                description={edit ?
                              runbookToEdit.runbook.description :
                                runbook_details?.runbook?.description}/>
              
              <h1 className="my-3" style={{fontSize: "1.2rem", color:"#DBE1F5"}}>Diagnostics</h1>
            
              <Diagnostics 
                id={runbook_details?.runbook?.id}
                sendDataToParent={handleDiagnosticFromChild}
                alertId={id}
                type="diagnostic"
                editable={edit}
                diagnostics={runbook_details?.instructions}
                viewingFull={handleView}
                runbook_created_at ={runbook_details?.runbook?.created_at}
              />
              <h1 className="my-3" style={{fontSize: "1.2rem", color:"#DBE1F5"}}>Recovery</h1>
              <Diagnostics 
                id={runbook_details?.runbook?.id}
                sendDataToParent={handleRecoveryFromChild}
                alertId={id}
                type="recovery"
                editable={edit}
                diagnostics={runbook_details?.recovery_instructions}
                viewingFull={handleView}
                runbook_created_at ={runbook_details?.runbook?.created_at}
              />
              <h1 className="my-3" style={{fontSize: "1.2rem", color:"#DBE1F5"}}>Conclusion</h1>
              <RunbookConclusion
                editable={edit}
                sendConclusionToParent={handleConclusionFromChild}
                conclusion={edit ? runbookToEdit.runbook?.conclusion :
                runbook_details?.runbook?.conclusion}/>
              {onRunBookPage && !edit && <Feedback id={runbook_details?.runbook?.id} />}
              {onRunBookPage && !edit && runbook_details?.runbook?.id && <AllFeedbacks id={runbook_details?.runbook?.id}/>}
            </div>
        </div>
       </div>
      }
    </React.Fragment>
  );
}

export default Runbook;
